<template>
  <div class="withdraw">
    <van-nav-bar
      class="nav-bar"
      title="積分兌換"
      left-arrow
      @click-left="back()"
    >
      <template #right>
        <span class="nav-right" @click="$router.push({ path: '/WithdrawRecord' })">提款記錄</span>
      </template>
    </van-nav-bar>

    <!-- 已選提款帳戶 -->
    <div class="card card-selected">
      <p
        class="selected-text"
        :class="{ 'is-placeholder': !hasWithdrawTarget, 'is-selected': hasWithdrawTarget }"
      >
        {{ selectedAccountLabel }}
      </p>
      <van-icon v-if="hasWithdrawTarget" name="passed" class="selected-check" />
    </div>

    <!-- 提款方式（自訂列 + 底部選擇，避免下拉標題長文與箭頭重疊模糊） -->
    <div class="card card-method" @click="showWithdrawPicker = true">
      <div class="method-picker-trigger">
        <span class="method-picker-text">{{ selectedAccountLabel }}</span>
        <van-icon name="arrow-down" class="method-picker-icon" />
      </div>
      <span class="method-label">提款方式</span>
    </div>

    <van-popup
      v-model="showWithdrawPicker"
      position="bottom"
      round
      :style="{ maxHeight: '75%' }"
      class="withdraw-method-popup"
    >
      <div class="withdraw-sheet">
        <p class="withdraw-sheet-title">選擇提款方式</p>
        <div v-if="banklistSelectable.length === 0" class="withdraw-sheet-empty">
          暫無可選帳戶，請先綁定銀行卡或 USDT 地址
        </div>
        <div v-else class="withdraw-sheet-list">
          <button
            v-for="opt in banklistSelectable"
            :key="withdrawOptionKey(opt)"
            type="button"
            class="withdraw-sheet-item"
            :class="{ 'is-active': opt.value == value1 }"
            @click="pickWithdrawOption(opt)"
          >
            <span class="withdraw-sheet-item-text">{{ opt.text }}</span>
            <van-icon v-if="opt.value == value1" name="success" class="withdraw-sheet-check" />
          </button>
        </div>
      </div>
    </van-popup>

    <!-- 兌換積分 -->
    <div class="card card-form">
      <p class="form-title">兌換積分 (TWD)</p>
      <div class="ipt">
        <p class="ipt-currency">TWD</p>
        <input
          v-model="withdraw_money"
          class="ipt-input"
          type="number"
          :placeholder="'可用積分' + (userInfo.money != null ? userInfo.money : '0.00')"
        />
        <span class="ipt-all" @click="allMoeny()">全部</span>
      </div>
      <div class="sm">
        <div class="tips">
          <button type="button" class="tips-link" @click.stop="showLimitSheet = true">
            <van-icon name="question-o" />
            提款限額
          </button>
        </div>
        <div class="syjf">
          剩餘積分：
          <span class="syjf-num">{{ userInfo.money || '0.00' }}TWD</span>
        </div>
      </div>
    </div>

    <van-dialog
      v-model="showDialog"
      class="withdraw-paypwd-dialog"
      :title="$t('setting.paypwdtitle')"
      show-cancel-button
      cancel-button-text="取消"
      confirm-button-text="確認"
      @confirm="onConfirm"
      @cancel="showDialog = false"
    >
      <van-field
        v-model="paypsd"
        ref="inputField"
        class="withdraw-paypwd-field"
        type="password"
        :placeholder="$t('setting.paypwd')"
        maxlength="32"
      />
    </van-dialog>

    <van-popup
      v-model="showLimitSheet"
      position="bottom"
      round
      get-container="body"
      class="withdraw-limit-popup"
    >
      <div class="limit-sheet">
        <p class="limit-sheet-title">提款限額說明</p>
        <ul class="limit-sheet-list">
          <li>單筆限額：最低 100.00 TWD，最高 1,000,000.00 TWD</li>
          <li>每日提款：最高 10,000,000.00 TWD</li>
          <li>提款次數：每日最高 999 次（免手續費 500 次）</li>
          <li>平均耗時約 5 分鐘到 2 小時，依序處理</li>
        </ul>
        <button type="button" class="limit-sheet-btn" @click="showLimitSheet = false">我知道了</button>
      </div>
    </van-popup>

    <div class="btn-wrap">
      <button type="button" class="submit-btn" @click="doWithdraw()">積分提款請求</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showDialog: false,
      paypsd: '',
      showLimitSheet: false,
      withdraw_money: '',
      userInfo: {},
      value1: 0,
      banklist: [{ text: '請選擇提款帳戶', value: 0 }],
      withdrawRole: {},
      showWithdrawPicker: false,
    };
  },
  computed: {
    banklistSelectable() {
      return this.banklist.filter((o) => o.value !== 0 && o.value !== '0');
    },
    hasWithdrawTarget() {
      return this.value1 !== 0 && this.value1 !== '0' && this.value1 != null && this.value1 !== '';
    },
    selectedAccountLabel() {
      const hit = this.banklist.find((o) => o.value == this.value1);
      return hit ? hit.text : '請選擇提款帳戶';
    },
  },
  methods: {
    back() {
      return window.history.back();
    },
    withdrawOptionKey(opt) {
      return String(opt.value);
    },
    pickWithdrawOption(opt) {
      this.value1 = opt.value;
      this.showWithdrawPicker = false;
    },
    maskCrypto(addr) {
      if (!addr || String(addr).length < 10) {
        return addr || '';
      }
      const s = String(addr);
      return `${s.slice(0, 6)}****${s.slice(-4)}`;
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info',
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    /** 後端 usdt_list 單項：text、value(usdt_bind.id)、protocol、address */
    formatUsdtOptionText(row) {
      if (row.text) {
        return row.text;
      }
      const proto = row.protocol || 'USDT';
      const addr = row.address ? this.maskCrypto(row.address) : '';
      return addr ? `${proto}（${addr}）` : String(proto);
    },
    getUserWithdrawRole() {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role',
      }).then((res) => {
        if (res.code === 200) {
          this.withdrawRole = res.data.data;
          const cash = [{ text: '現金提款', value: 'cash' }];
          const banks = (res.data.list || []).map((row) => ({
            text: row.text,
            value: `bank:${row.value}`,
          }));
          const usdts = (res.data.usdt_list || []).map((row) => ({
            text: this.formatUsdtOptionText(row),
            value: `usdt:${row.value}`,
          }));
          this.banklist = [{ text: '請選擇提款帳戶', value: 0 }].concat(cash, banks, usdts);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    allMoeny() {
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw() {
      const isCashWithdraw = String(this.value1) === 'cash';
      if (!isCashWithdraw && this.withdraw_money <= 0) {
        this.$toast(this.$t('withdraw.enterCorrectAmount'));
        return false;
      }
      if (this.value1 === 0 || this.value1 === '0') {
        this.$toast('請選擇提款帳戶（現金、銀行卡或 USDT 地址）');
        return false;
      }
      this.showDialog = true;
      return undefined;
    },
    onConfirm() {
      if (this.paypsd === '') {
        this.$toast(this.$t('withdraw.enterPayPassword'));
        return false;
      }
      this.$http({
        method: 'post',
        data: { password: this.paypsd },
        url: 'user_check_paypw',
      }).then((res) => {
        if (res.code === 200) {
          this.dosubmit();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
      return undefined;
    },
    dosubmit() {
      const v = this.value1;
      const s = String(v);
      let data = {};
      if (s === 'cash') {
        data = {
          channel: 'cash',
          bankid: 0,
          money: this.withdraw_money,
          username: this.userInfo.username || '',
          name: this.userInfo.name || '',
        };
      } else if (s.startsWith('usdt:')) {
        data.money = this.withdraw_money;
        data.channel = 'usdt';
        data.usdt_bind_id = s.slice(5);
      } else if (s.startsWith('bank:')) {
        data.money = this.withdraw_money;
        /* 銀行卡與文檔一致可只傳 bankid，不帶 channel，兼容舊後端 */
        data.bankid = s.slice(5);
      } else {
        data.money = this.withdraw_money;
        /* 兼容舊接口：僅返回數字 bankid、無前綴 */
        data.bankid = v;
      }
      this.$http({
        method: 'post',
        data,
        url: 'user_set_withdraw',
      }).then((res) => {
        if (res.code === 200) {
          location.reload();
          this.$toast(res.msg);
          this.getUserInfo();
          this.getUserWithdrawRole();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';

@grad-start: #f560cd;
@grad-end: #4f2b8a;

.withdraw {
  width: 100%;
  min-height: 100%;
  padding-bottom: 2rem;
  box-sizing: border-box;
  background: linear-gradient(180deg, #fce8f4 0%, #f3f3f5 28%);
}

.nav-bar {
  position: relative;
}

.withdraw::v-deep .nav-bar.van-nav-bar {
  background: linear-gradient(90deg, @grad-start, @grad-end);
}

.withdraw::v-deep .nav-bar.van-nav-bar::after {
  display: none;
}

.withdraw::v-deep .nav-bar .van-nav-bar__title {
  color: #fff;
  font-size: 36px;
  font-weight: 600;
  max-width: 58%;
}

.withdraw::v-deep .nav-bar .van-icon {
  color: #fff;
  font-size: 40px;
}

.nav-right {
  color: #fff;
  font-size: 28px;
  padding: 0 8px;
}

/* 三張白卡 + 底部按鈕統一為 92% 寬，避免 .card-selected 另設 width 覆蓋 .card 造成錯位 */
.withdraw .card {
  width: 92%;
  max-width: 100%;
  margin: 18px auto 0;
  padding: 22px 20px;
  background: #fff;
  border-radius: 12px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(79, 43, 138, 0.08);
}

.card-selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
}

.selected-text {
  flex: 1;
  min-width: 0;
  margin: 0;
  padding-right: 12px;
  color: #111;
  font-size: 30px;
  font-weight: 600;
  line-height: 1.35;
  word-break: break-all;
  text-align: left;
}

/* 已選帳戶（第一張卡）：靠左、藍字 — 與設計稿一致 */
.selected-text.is-selected {
  color: #1989fa;
  font-weight: 600;
}

.selected-text.is-placeholder {
  color: #999;
  font-weight: 400;
}

.selected-check {
  flex-shrink: 0;
  color: #735fb1;
  font-size: 40px;
}

.card-method {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.method-picker-trigger {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.method-picker-text {
  flex: 1;
  min-width: 0;
  color: #111;
  font-size: 28px;
  font-weight: 600;
  line-height: 1.45;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-font-smoothing: antialiased;
}

.method-picker-icon {
  flex-shrink: 0;
  color: #888;
  font-size: 28px;
}

.method-label {
  flex-shrink: 0;
  color: #333;
  font-size: 28px;
  font-weight: 500;
}

.withdraw-sheet {
  padding: 16px 16px 28px;
  box-sizing: border-box;
}

.withdraw-sheet-title {
  margin: 0 0 12px;
  padding: 8px 4px 12px;
  color: #666;
  font-size: 26px;
  text-align: center;
  border-bottom: 1px solid #eee;
}

.withdraw-sheet-list {
  max-height: 52vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.withdraw-sheet-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin: 0;
  padding: 18px 12px;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  color: #111;
  font-size: 28px;
  line-height: 1.45;
  text-align: left;
  background: #fff;
  -webkit-font-smoothing: antialiased;
}

.withdraw-sheet-item:last-child {
  border-bottom: none;
}

.withdraw-sheet-item.is-active {
  background: #f9f6ff;
}

.withdraw-sheet-item-text {
  flex: 1;
  min-width: 0;
  word-break: break-all;
}

.withdraw-sheet-check {
  flex-shrink: 0;
  color: #735fb1;
  font-size: 32px;
}

.withdraw-sheet-empty {
  padding: 28px 16px;
  color: #999;
  font-size: 26px;
  line-height: 1.5;
  text-align: center;
}

.card-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.form-title {
  margin: 0 0 8px;
  color: #442b89;
  font-size: 30px;
  font-weight: 600;
}

.ipt {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 12px 0 8px;
  border: none;
}

.ipt-currency {
  flex-shrink: 0;
  margin: 0;
  padding-right: 12px;
  font-size: 28px;
  color: #333;
}

.ipt input,
.ipt-input {
  flex: 1;
  min-width: 0;
  border: none;
  padding: 12px 0;
  font-size: 28px;
  color: #111;
  background: transparent;
  -webkit-font-smoothing: antialiased;
}

.ipt input::placeholder {
  color: #999;
  font-size: 26px;
}

.ipt-all {
  flex-shrink: 0;
  padding-left: 12px;
  color: #735fb1;
  font-size: 28px;
}

.sm {
  width: 100%;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.tips {
  text-align: right;
  width: 100%;
  font-size: 26px;
}

.tips-link {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin: 0;
  padding: 8px 4px;
  border: none;
  font: inherit;
  font-size: 26px;
  color: #6c55ae;
  background: transparent;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.syjf {
  width: 100%;
  padding-top: 14px;
  color: #2e0d67;
  font-size: 28px;
}

.syjf-num {
  color: #d53dde;
  font-weight: 600;
}

.withdraw::v-deep .withdraw-limit-popup.van-popup {
  max-height: 55%;
}

.limit-sheet {
  padding: 20px 20px 28px;
  box-sizing: border-box;
}

.limit-sheet-title {
  margin: 0 0 16px;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  color: #442b89;
}

.limit-sheet-list {
  margin: 0;
  padding: 0 0 8px 1.2em;
  font-size: 26px;
  line-height: 1.55;
  color: #3d2a6e;
  text-align: left;
}

.limit-sheet-list li {
  margin-bottom: 12px;
}

.limit-sheet-list li:last-child {
  margin-bottom: 0;
}

.limit-sheet-btn {
  display: block;
  width: 100%;
  margin-top: 16px;
  padding: 14px;
  border: none;
  border-radius: 12px;
  font-size: 28px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(90deg, #e9557f, #7e55e9);
  -webkit-tap-highlight-color: transparent;
}

.btn-wrap {
  display: flex;
  justify-content: center;
  padding: 36px 16px 24px;
}

.submit-btn {
  width: 92%;
  height: 52px;
  border: none;
  border-radius: 26px;
  color: #fff;
  font-size: 32px;
  font-weight: 600;
  background: linear-gradient(90deg, #e9557f, #7e55e9);
  box-shadow: 0 4px 16px rgba(126, 85, 233, 0.35);
}

.withdraw::v-deep .withdraw-paypwd-dialog .van-dialog__header {
  color: #fff;
  font-size: 30px;
  font-weight: 600;
  background: linear-gradient(90deg, @grad-end, @grad-start);
}

.withdraw::v-deep .withdraw-paypwd-dialog .van-dialog__content {
  padding: 20px 16px 8px;
}

.withdraw::v-deep .withdraw-paypwd-field.van-field {
  width: 100%;
  margin: 0;
  padding: 12px 14px;
  background: #f7f8fa;
  border-radius: 8px;
}

.withdraw::v-deep .withdraw-paypwd-field .van-field__label {
  display: none;
}

.withdraw::v-deep .withdraw-paypwd-field .van-field__control {
  font-size: 28px;
  line-height: 1.4;
}

.withdraw::v-deep .withdraw-paypwd-dialog .van-dialog__cancel,
.withdraw::v-deep .withdraw-paypwd-dialog .van-dialog__confirm {
  font-size: 30px;
}

.withdraw::v-deep .withdraw-method-popup.van-popup {
  -webkit-font-smoothing: antialiased;
}
</style>
